import { Injectable } from '@angular/core';

const COACHING_RESISTANCE_THRESHOLDS: Record<'easy' | 'soft' | 'medium' | 'hard', number> = {
  easy: 37,
  soft: 53,
  medium: 70,
  hard: 85,
};

export enum CoachingIntervalColorRef {
  easy = '#428ff3',
  soft = '#50AD5A',
  medium = '#FFD166',
  hard = '#FDA250',
  expert = '#D25E58',
}

@Injectable({
  providedIn: 'root',
})
export class ColorService {
  getColor(resistance: number | undefined): CoachingIntervalColorRef {
    const value: number = resistance ?? 0;

    if (value <= COACHING_RESISTANCE_THRESHOLDS.easy) {
      return CoachingIntervalColorRef.easy;
    }

    if (value <= COACHING_RESISTANCE_THRESHOLDS.soft) {
      return CoachingIntervalColorRef.soft;
    }

    if (value <= COACHING_RESISTANCE_THRESHOLDS.medium) {
      return CoachingIntervalColorRef.medium;
    }

    if (value <= COACHING_RESISTANCE_THRESHOLDS.hard) {
      return CoachingIntervalColorRef.hard;
    }

    return CoachingIntervalColorRef.expert;
  }
}
